<template>
  <div class="sidebar-wrapper sidebar-custom custom-scroll-bar-2" ref="sidebarScrollArea">
    <md-list class="nav h_100" :class="{'ps' : tab === 'notification' || tab === 'messenger', 'overflow-y-overlay_hover' : tab !== 'notification' || tab !== 'messenger'}">
      <div v-if="tab === 'workplace'" class="social-bar">
        <WorkPlaceSideBar/>
      </div>
      <div v-if="tab === 'notification'" class="notification-bar">
        <NotificationSideBar/>
      </div>
      <div v-if="tab === 'category'" class="social-bar">
        <CategorySideBar/>
      </div>
      <div v-if="tab === 'company-structure'" class="social-bar">
        <company-structure/>
      </div>
      <div v-if="tab === 'messenger'" class="social-bar">
        <MessageSideBar/>
      </div>
      <div v-if="tab === 'admin-settings'" class="social-bar">
        <AdminSettingSideBar/>
      </div>
      <div v-if="tab === 'wiki'" class="social-bar">
        <WikiSideBar/>
      </div>
    </md-list>
  </div>
</template>

<script>
import CompanyStructure from "./CompanyStructureSideBar";
import NotificationSideBar from "./SideBarContent/NotificationSideBar";
import CategorySideBar from "./SideBarContent/CategorySideBar";
import WorkPlaceSideBar from "./SideBarContent/WorkPlaceSideBar";
import MessageSideBar from "./SideBarContent/MessageSideBar";
import AdminSettingSideBar from "./SideBarContent/AdminSettingSideBar";
import WikiSideBar from "./SideBarContent/WikiSideBar";

export default {
  name: "SidebarContentColumn",
  components: {
    CompanyStructure,
    NotificationSideBar,
    CategorySideBar,
    WorkPlaceSideBar,
    MessageSideBar,
    AdminSettingSideBar,
    WikiSideBar,
  },
  props: {
    tab: {
      type: String,
      default: "workplace",
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
